import { TooltipProvider } from "@rulebase/core/components";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "sonner";
import { AuthGate } from "./components/auth-gate";
import SidebarPage from "./components/sidebar-page";
import { usePostHogIdentify } from "./hooks/use-posthog-identify";
import { useSessionActivityReporter } from "./hooks/use-session-activity-reporter";

// Guard against blocked/failed Sentry initialization so the app can still load.
try {
  Sentry.init({
    dsn: "https://cd24044b4ec9fe65920c9fc7a40f163e@o4508043105665024.ingest.de.sentry.io/4510079268421712",
    sendDefaultPii: true,
    integrations: [
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
    ],
    enableLogs: true,
  });
} catch (error) {
  console.error("Error initializing sentry", error);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

function PostHogIdentify() {
  usePostHogIdentify();
  return null;
}

function SessionActivityReporter() {
  useSessionActivityReporter();
  return null;
}

function App({ posthogEnabled = false }: { posthogEnabled?: boolean }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={0}>
        <div className="text-base">
          <AuthGate>
            {posthogEnabled ? <PostHogIdentify /> : null}
            <SessionActivityReporter />
            <SidebarPage />
          </AuthGate>
          <Toaster position="top-center" />
        </div>
      </TooltipProvider>

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
